<template>
    <div class="card pickup">
        <div class="filtered" v-if="isFilter" @click="showR18()">
            <span class="badge badge-danger">R18作品</span>
        </div>
        <div class="img-column">
            <img :src="novel.cover_url.replace(/\.webp$/, '_thumb.webp') + '?' + novel.cover_hash" class="mx-auto d-block cover" v-if="novel.cover_url" />
            <img v-lazy="cover()" class="mx-auto d-block cover" v-else />
            <div class="cover-text">
                <h5 class="card-title mincho">
                    <span v-if="isMypage" v-html="$filters.ruby(novel.title)"></span>
                    <router-link :to="pickupUrl" class="black stretched-link" v-else>
                        <span v-html="$filters.ruby(novel.title)"></span>
                    </router-link>
                </h5>
                <p class="small" v-html="desc"></p>
            </div>
        </div>
        <div class="card-footer text-right" v-if="isMypage">
            <button type="button" class="btn btn-outline-danger btn-sm" @click="removePickup()">
                <i class="fas fa-times-circle"></i>
                削除
            </button>
        </div>
    </div>
</template>

<style scoped lang="scss">
.pickup {
    width: 213px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    .img-column {
        background-color: black;
        position: relative;
        height: 300px;
        .cover {
            object-fit: cover;
            width: 213px;
            height: 300px;
        }
        .cover-text {
            color: snow;
            a {
                color: snow;
            }
            position: absolute;
            background-color: rgba(0, 0, 0, .55);
            opacity: 1;
            padding: 1rem;
            top: 0px;
            height: 300px;
            width: 100%;
            transition: 0.2s ease;
            font-size: .7rem;
            .card-title {
                font-size: 1rem;
            }
            &:hover {
                opacity: 0.3;
            }
        }
    }
    .card-body {
        height: 300px;
    }
    .card-footer {
        z-index: 10;
    }
}
</style>

<script>
export default {
    props: {
        novel: {
            required: true
        }
    },
    methods: {
        removePickup() {
            this.$emit("removePickup", this.novel);
        },
        showR18() {
            $("#r18-modal").modal();
        },
        cover() {
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
    },
    computed: {
        pickupUrl() {
            if (! this.novel.is_long) {
                return "/author/page/" + this.novel.id + "/section/" + this.novel.sections[0].id;
            }
            return "/author/book/" + this.novel.id;
        },
        isMypage() {
            if (this.$route.path.match(/mypage/)) {
                return true;
            }
            return false;
        },
        desc() {
            const d = this.$filters.wrap(this.novel.description);
            return this.$filters.truncate(d, 120);
        },
        isFilter() {
            if (this.novel?.rating?.rating_level >= 2 && !this.$store.state.user && !this.$store.state.r18) {
                return true;
            }
            return false;
        },
    },
}
</script>